import { useTranslation } from 'react-i18next';
import { Segmented } from '@/components/ui';
import { useMobileShell } from '@/hooks/useMobileShell';
import type { RecordTab } from '@/hooks/useRecordTab';

/**
 * 「本工地 / 我的」（CR-042）。两个都能看的人才渲染它，调用方自己判。
 *
 * CR-082：分段按钮，放在工具条最左边（电脑）/ 单独一行撑满（手机）。它换的是「看谁的」，
 * 不是要处理的状态，所以不和状态页签长一个样。「本工地」在前 —— 它是默认（CR-048）。
 */
export function RecordTabs({ tab, onChange }: { tab: RecordTab; onChange: (next: RecordTab) => void }) {
  const { t } = useTranslation();
  const mobile = useMobileShell();
  return (
    <div data-record-tabs className={mobile ? 'w-full' : undefined}>
      <Segmented<RecordTab>
        label={t('records.site')}
        hideLabel
        block={mobile}
        options={[
          { value: 'site', label: t('records.site') },
          { value: 'mine', label: t('records.mine') },
        ]}
        value={tab}
        onChange={onChange}
      />
    </div>
  );
}
